import { css } from 'styled-components';
import { media } from '../../../helpers/mixins';

export default {
  container: css`
    display: flex;
    flex: 1;
    align-items: flex-start;
    justify-content: space-around;
    ${media.sm`
      margin-bottom: 1rem;
    `}
    ${media.md`
      width: 50%;
    `};
  `,
  line :css`
    background: #9078B5;
    height: 3px;
    width: 50px;
    margin: 0;
    padding: 0px;
    margin-top: 15px;
    ${media.sm`
      width: 200px;
    `}
    ${media.md`
      width: 400px;
    `}
  `
};
